import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SortConfiguration } from '../components/generics/data-table/data-table.component';
import { Cobertura, TipoProducto } from '../models/cobertura.model';
import { UtilsService } from './utils.service';

@Injectable({
    providedIn: 'root'
})
export class CoberturasService {

    constructor(
        private http: HttpClient,
        private utilsService: UtilsService
    ) { }

    getCoberturas(page: number, itemsPerPage: number, sorts: SortConfiguration[], tipoProducto?: TipoProducto, ocultarInactivos = true) {
        const url = '/calculadora/coberturas';
        const headers = {
            'page-number': String(page),
            'page-size': String(itemsPerPage)
        };
        const params: any = {
            'sort-by': this.utilsService.generateSortQueryParam(sorts),
            'ocultar-inactivos': String(ocultarInactivos)
        };
        if (tipoProducto) {
            params['tipo-producto'] = tipoProducto;
        }
        return this.http.get<Cobertura[]>(url, { headers, observe: 'response', params });
    }

    getCoberturaById(id: number) {
        return this.http.get<Cobertura>(`/calculadora/coberturas/${id}`);
    }

    createCobertura(cobertura: Cobertura) {
        return this.http.post<Cobertura>('/calculadora/coberturas', cobertura);
    }

    updateCobertura(cobertura: Cobertura) {
        return this.http.put<Cobertura>(`/calculadora/coberturas/${cobertura.id}`, cobertura);
    }

    deleteCobertura(id: number) {
        return this.http.delete<Cobertura>(`/calculadora/coberturas/${id}`);
    }
}
